import { jsxs as i, jsx as r } from "react/jsx-runtime";
import { Clock as t } from "@pelando/fontawesome/icons";
import { TimestampArea as m, TimestampIcon as l, PublishDate as c } from "./style.js";
const n = "Hora da publicação";
function d({
  timestamp: e,
  timestampTitle: a = n,
  keepMobileLayout: o = !1
}) {
  return /* @__PURE__ */ i(
    m,
    {
      "data-keep-mobile-layout": o,
      title: a,
      children: [
        /* @__PURE__ */ r(l, { icon: t, "aria-label": a }),
        /* @__PURE__ */ r(c, { "data-keep-mobile-layout": o, children: e })
      ]
    }
  );
}
export {
  n as DEFAULT_TIMESTAMP_TITLE,
  d as Timestamp
};
